module.exports = __webpack_public_path__ + "static/media/earthnight.e0f87df3.png";